import { Box, Button, Chip } from "@mui/material";
import React from "react";

import { grey } from "@mui/material/colors";
import Flx from "../../layout/Flx";
import Txt from "../../typography/Txt";

const SidebarDetailSection = ({
  title,
  children,
  description,
  count,
  action,
  actionLabel,
  py = 2,
  headerMb = 1.5,
  // headerMb = 2,
  // headerMb = 1,
  pt,
  pb,
  endContent,
  sx,
}) => (
  <Box
    sx={{
      px: 1.5,

      ...sx,
    }}
  >
    <Flx
      ac
      jb
      sx={{
        //
        mb: headerMb,
        // mb: 1.5,
      }}
    >
      <Flx fw jb wrap ac gap={1}>
        <Flx ac gap={1}>
          <Flx column>
            <Flx ac gap={1}>
              <Txt
                sx={{
                  // fontSize: "14px",
                  // fontWeight: 700,
                  // textTransform: "uppercase",
                  // letterSpacing: ".5px",

                  // ---
                  fontSize: 11.5,
                  fontWeight: 700,
                  color: "rgb(100, 116, 139)",
                  letterSpacing: "0.06em",
                  textTransform: "uppercase",
                }}
              >
                {title}
              </Txt>
              {count !== undefined && (
                <Chip
                  label={count}
                  size="small"
                  sx={{
                    height: 18,
                    fontSize: "10px",
                    fontWeight: 700,
                    bgcolor: grey[100],
                    color: grey[600],
                  }}
                />
              )}
            </Flx>
            {description && <Txt secondary>{description}</Txt>}
          </Flx>
        </Flx>
        {endContent}
      </Flx>
      {action && (
        <Button
          size="small"
          variant="text"
          onClick={action}
          sx={{ fontSize: "11px", minWidth: "auto" }}
        >
          {actionLabel || "View All"}
        </Button>
      )}
    </Flx>
    {children}
  </Box>
);

export default SidebarDetailSection;
